module.exports = __webpack_public_path__ + "static/2b-bcg-leon-crop-7dc6b64444cc7fa615ae266f52044169.jpg";